module.exports = __webpack_public_path__ + "static/media/pinterest.6003b4e4.svg";